<template>
  <div class="wrapper">
    <div  class="modal">
      <div @click="close()" class="close">x</div>
      <div class="info" v-for="(e, name, i) in selectedProfile.userProfile" :key="i"><b>{{name}}</b><br/>{{e}}<br/><br/></div>
    </div>
  </div>
</template>

<script>
import store from '../../../../store';

  export default {
    name: 'NewProfileModal',
    computed: {
      selectedProfile()  {
        return store.state.userAccounts.find(e => e.id === store.state.selectedUserProfileId)
        // return store.state.userAccounts[store.state.selectedUserProfileIndex]
      }
    },
    methods: {
      close() {
        store.commit('setSelectedUserProfileId', null)
      }

    }
  }
</script>

<style lang="sass" scoped>
.modal
  position: fixed
  inset: 0 0 0 auto
  padding: 50px
  max-width: 80%
  width: 1100px
  background-color: white
  z-index: 100
  box-shadow: 0 0 400px 400px rgba(0, 0, 0, 0.1)
  overflow-y: scroll

  .close
    position: fixed
    inset: 0 0 auto auto
    background-color: black
    width: 50px
    height: 50px
    color: white
    display: flex
    align-items: center
    justify-content: center
    cursor: pointer
    font-weight: 600
</style>